import { useLoanContext } from "@/screens/loans/components/LoanContext"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { Defs, G, LinearGradient, Path, Stop, Svg } from "react-native-svg"
import { useStore } from "@nanostores/react"
import { H5, H6, Small } from "@/components/standard/BFText"
import { Linking, Pressable, View } from "react-native"
import { BFCloseButton } from "@/components/standard/BFCloseButton"
import { useCallback } from "react"
import { Sentry } from "@/hooks/sentry"
import { persistentAtom } from "@nanostores/persistent"
import { createComponentClickedEvent, track } from "@/analytics/events/base"

function ArrowClipart() {
  return (
    <Svg width={44} height={45} viewBox="0 0 44 45" fill="none">
      <G>
        <Path
          d="M17.248 15.12l2.461.619a.388.388 0 00-.116-.053l-2.462-.62c.042.011.081.029.117.053z"
          fill="#fff"
        />
        <Path
          d="M19.704 15.79a.05.05 0 00.033-.091.428.428 0 00-.132-.06l-2.461-.62a.049.049 0 00-.059.037.05.05 0 00.035.06c.036.01.07.025.101.046a.06.06 0 00.015.007l2.462.62h.005z"
          fill="#121F3A"
        />
        <Path
          d="M7.994 41.584l9.924-18.29a.274.274 0 01.304-.147l2.462.62a.274.274 0 00-.305.147l-9.923 18.29a.274.274 0 01-.304.146l-2.462-.62a.274.274 0 00.304-.146z"
          fill="url(#paint0_linear_5335_40346)"
        />
        <Path
          d="M10.175 42.405a.328.328 0 00.324-.177l9.924-18.29a.224.224 0 01.25-.122.05.05 0 00.06-.035.05.05 0 00-.035-.061h-.002l-2.462-.62a.325.325 0 00-.36.17L7.952 41.56a.226.226 0 01-.25.122.049.049 0 00-.06.034.05.05 0 00.035.061h.003l2.461.62a.323.323 0 00.035.007zm10.28-18.644a.35.35 0 00-.118.129l-9.924 18.29a.226.226 0 01-.249.121l-2.245-.565a.353.353 0 00.119-.128l9.923-18.29a.224.224 0 01.25-.122l2.245.565z"
          fill="#121F3A"
        />
        <Path
          d="M19.71 15.74l6.09 5.888a.247.247 0 00.069.029l-2.463-.62a.246.246 0 01-.068-.029l-6.09-5.887 2.462.62v-.001z"
          fill="#fff"
        />
        <Path
          d="M25.862 21.705a.05.05 0 00.018-.097.195.195 0 01-.05-.02l-6.086-5.884a.05.05 0 00-.023-.012l-2.461-.62a.049.049 0 00-.06.036.05.05 0 00.014.048l6.09 5.887.009.007a.292.292 0 00.082.035l2.461.62h.007zm-6.177-5.92l5.964 5.764-2.23-.56a.194.194 0 01-.051-.021l-5.952-5.755 2.27.571z"
          fill="#121F3A"
        />
        <Path
          d="M24.8 28.982l9.008-16.602a.274.274 0 01.304-.146l2.462.62a.274.274 0 00-.304.146l-9.008 16.602a.258.258 0 01-.301.135l-2.462-.62a.258.258 0 00.301-.135z"
          fill="url(#paint1_linear_5335_40346)"
        />
        <Path
          d="M26.991 29.793c.13.018.256-.05.314-.167l9.008-16.602a.226.226 0 01.25-.122.049.049 0 00.059-.036.05.05 0 00-.036-.06l-2.462-.62a.325.325 0 00-.36.17l-9.007 16.602a.21.21 0 01-.246.111.049.049 0 00-.06.035.05.05 0 00.034.06l.003.002 2.461.62a.305.305 0 00.042.007zm9.354-16.945a.352.352 0 00-.118.128l-9.008 16.602a.21.21 0 01-.247.111l-2.236-.563a.33.33 0 00.107-.12l9.009-16.602a.226.226 0 01.248-.121l2.245.565z"
          fill="#121F3A"
        />
        <Path
          d="M37.375.756l2.462.62a.26.26 0 00-.072-.03l-2.461-.62c.025.006.05.016.071.03z"
          fill="#fff"
        />
        <Path
          d="M39.831 1.424a.05.05 0 00.032-.091.307.307 0 00-.086-.037l-2.462-.62a.05.05 0 00-.06.035.05.05 0 00.035.061h.002c.02.006.04.014.057.025a.05.05 0 00.015.006l2.461.62h.006v.001z"
          fill="#121F3A"
        />
        <Path
          d="M39.837 1.376a.287.287 0 01.131.254l-.243 12.642c-.005.198-.178.336-.342.295l-2.462-.62c.165.041.338-.096.341-.295l.244-12.642a.287.287 0 00-.131-.255l2.462.62z"
          fill="#fff"
        />
        <Path
          d="M39.406 14.621a.31.31 0 00.229-.065.362.362 0 00.139-.283l.244-12.642a.336.336 0 00-.155-.298.05.05 0 00-.014-.006l-2.462-.62a.05.05 0 00-.037.09c.07.046.111.127.107.212l-.243 12.642c0 .08-.038.157-.102.207a.209.209 0 01-.179.04.05.05 0 10-.026.095l.003.002h.001l2.461.62a.267.267 0 00.035.006zm.411-13.2a.238.238 0 01.102.207l-.244 12.642c0 .081-.038.157-.1.207a.21.21 0 01-.18.04l-2.245-.564.023-.017a.362.362 0 00.14-.283l.242-12.642a.359.359 0 00-.037-.168l2.3.579z"
          fill="#121F3A"
        />
        <Path
          d="M37.375.756a.25.25 0 00-.272.004L26.956 7.27c-.183.117-.19.402-.009.514l2.667 1.651c.13.091.171.267.092.405L23.71 20.89a.266.266 0 01-.358.125l-.015-.008-6.09-5.887c-.17-.113-.338-.064-.418.082L3.894 39.045a.305.305 0 00.092.405L7.62 41.7c.129.074.293.03.365-.1l.009-.016 9.923-18.29a.267.267 0 01.374-.117l6.09 5.887c.17.114.34.065.419-.081l9.008-16.603a.266.266 0 01.374-.116l2.667 1.652c.18.112.41-.036.414-.264l.243-12.642a.287.287 0 00-.131-.255z"
          fill="#75FAD4"
        />
        <Path
          d="M7.713 41.785a.295.295 0 00.115-.008.34.34 0 00.21-.169l9.923-18.29a.242.242 0 01.149-.122.198.198 0 01.152.02l6.085 5.883a.36.36 0 00.296.068.316.316 0 00.2-.16l9.009-16.603a.242.242 0 01.148-.12.199.199 0 01.157.022l2.667 1.652a.3.3 0 00.305.006.36.36 0 00.183-.311l.243-12.642A.336.336 0 0037.4.713a.298.298 0 00-.324.005L26.93 7.228a.36.36 0 00-.163.311c-.001.116.058.225.155.287l2.667 1.652a.256.256 0 01.074.338l-5.995 11.05a.24.24 0 01-.149.121.194.194 0 01-.15-.02l-6.086-5.883a.362.362 0 00-.294-.067.317.317 0 00-.2.162L3.85 39.022a.353.353 0 00.11.47l3.633 2.25a.298.298 0 00.12.043zM18.2 23.092a.293.293 0 00-.115.008.337.337 0 00-.21.17L7.952 41.56a.242.242 0 01-.148.12.2.2 0 01-.158-.022l-3.633-2.25a.256.256 0 01-.074-.339l12.936-23.843a.219.219 0 01.139-.113.261.261 0 01.205.046l6.086 5.884a.293.293 0 00.24.04.338.338 0 00.21-.17l5.996-11.05a.357.357 0 00-.11-.47L26.973 7.74a.237.237 0 01-.108-.203.262.262 0 01.118-.227L37.13.802a.201.201 0 01.22-.004c.07.046.111.126.107.21l-.244 12.643c0 .094-.05.18-.131.227a.2.2 0 01-.207-.004l-2.667-1.652a.296.296 0 00-.234-.034.34.34 0 00-.21.169l-9.008 16.602a.217.217 0 01-.138.113.264.264 0 01-.207-.047l-6.086-5.883a.294.294 0 00-.127-.049h.001z"
          fill="#121F3A"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_5335_40346"
          x1={18.8386}
          y1={23.6414}
          x2={8.87341}
          y2={41.6744}
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset={0.5} stopColor="#286588" />
          <Stop offset={1} stopColor="#121F3A" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_5335_40346"
          x1={35.0156}
          y1={12.8664}
          x2={25.8916}
          y2={28.1887}
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset={0.5} stopColor="#286588" />
          <Stop offset={1} stopColor="#121F3A" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

const URL = "https://tracking.thecreditpros.com/aff_c?offer_id=127&aff_id=3979"
const PHONE = "7273251301"

export const $creditScoreRepair = persistentAtom<"true" | "false">(
  "creditScoreRepair",
  "true"
)

export const CreditRepairWidget = () => {
  const { loanApplication } = useLoanContext()
  const shouldShow = useStore($creditScoreRepair)

  const onCall = useCallback(() => {
    const url = `tel:${PHONE}`
    track(
      createComponentClickedEvent({
        current_screen: "Loan Dashboard",
        component_id: "credit-repair-call-now",
        component_type: "text_link",
        component_function: url,
      })
    )

    Linking.canOpenURL(url)
      .then(async (supported) => {
        if (supported) {
          return await Linking.openURL(url)
        } else {
          Sentry.captureException(
            new Error(`Unable to open phone call this device for: ${url}`)
          )
        }
      })
      .catch((err) => {
        Sentry.captureException(err)
      })
  }, [])

  const onLearnMore = useCallback(() => {
    const url = URL
    track(
      createComponentClickedEvent({
        current_screen: "Loan Dashboard",
        component_id: "credit-repair-learn-more",
        component_type: "text_link",
        component_function: url,
      })
    )
    Linking.canOpenURL(url)
      .then(async (supported) => {
        if (supported) {
          return await Linking.openURL(url)
        } else {
          Sentry.captureException(
            new Error(`Unable to open learn moreon this device for: ${url}`)
          )
        }
      })
      .catch((err) => {
        Sentry.captureException(err)
      })
  }, [])

  if (shouldShow === "false" || loanApplication.creditScore !== "Below 640") {
    return null
  }

  return (
    <Vertical
      className={"border border-light-grey rounded-md pt-6 relative bg-white"}
    >
      <Horizontal className={"justify-between w-full  px-5"}>
        <Vertical className={"flex-1 pb-6 gap-1"}>
          <H5 color={"primary"}>Boost your credit, lower your rate</H5>
          <Small color={"primary"}>
            For every 10-point boost in your credit score, your interest rate
            goes down by 0.05%
          </Small>
        </Vertical>
        <View className={"px-4 justify-center items-center"}>
          <ArrowClipart />
        </View>
      </Horizontal>
      <View className="absolute top-3 right-3 size-4">
        <BFCloseButton
          dark={true}
          onPress={() => {
            track(
              createComponentClickedEvent({
                current_screen: "Loan Dashboard",
                component_id: "credit-repair-close",
                component_type: "text_link",
                component_function: "close credit repair widget",
              })
            )
            $creditScoreRepair.set("false")
          }}
        />
      </View>
      <Horizontal className={"px-4 py-3  bg-grey items-center justify-between"}>
        <H6 color={"primary"}>The Credit Pros</H6>
        <Horizontal className={"gap-2 items-center"}>
          <Pressable onPress={onCall} testID={"credit-repair-call-now"}>
            <H6 color={"primaryLight"} className={"underline"}>
              Call: (727) 325-1301
            </H6>
          </Pressable>
          <H6 color={"primaryLight"}> | </H6>
          <Pressable onPress={onLearnMore} testID={"credit-repair-learn-more"}>
            <H6 color={"primaryLight"} className={"underline"}>
              Learn More
            </H6>
          </Pressable>
        </Horizontal>
      </Horizontal>
    </Vertical>
  )
}
